import React from 'react';
import './SmallCircle.styles.css';

export const SmallCircle: React.FC = () => {
  return (
    <div className="small-circle"></div>
  );
};
